export const TimezoneDisplay = {
  Central: 'central',
  Listener: 'listener',
};
